import React from 'react';
import { useTranslation } from 'react-i18next';
import useStyles from './StatusBulletStyles';
export default function StatusBullet({
  status,
  text
}) {
  const {
    statusBulletRoot,
    bullet,
    bulletGreen,
    bulletYellow,
    bulletGrey,
    bulletRed
  } = useStyles();
  const ColorClass = {
    green: bulletGreen,
    yellow: bulletYellow,
    grey: bulletGrey,
    red: bulletRed
  };
  const {
    t
  } = useTranslation();
  const statusValue = text || t(`status.${status}`);
  return /*#__PURE__*/React.createElement("span", {
    className: statusBulletRoot
  }, /*#__PURE__*/React.createElement("span", {
    className: `${bullet} ${ColorClass[status]}`
  }), /*#__PURE__*/React.createElement("span", null, statusValue));
}
StatusBullet.defaultProps = {
  text: null
};